const throttle = (fn, threshold = 100, scope = null) => {
  let last = 0
  let deferTimer = null
  return function () {
    const context = scope || this
    let now = Date.now()
    let args = arguments
    if (last && now < last + threshold) {
      clearTimeout(deferTimer)
      deferTimer = setTimeout(() => {
        last = now
        fn.apply(context, args)
      }, threshold)
    } else {
      last = now
      fn.apply(context, args)
    }
  }
}

export default throttle



// WEBPACK FOOTER //
// ./src/util/throttle.js